<template>
  <!-- Layout inner -->
  <div class="layout-inner entity_detail">
    <!-- Layout navbar -->
    <navbar></navbar>
    <!-- / Layout navbar -->
    <div class="layout-container">
      <div class="layout-content can_full_screen">

        <div class="hd_bar">
          <div class="hd_ic ic-course"></div>
          <div class="hd_txt">
            <v-clamp class="title_txt" autoresize :max-lines="2" id="courseTitle">{{ course.title }}</v-clamp>

            <b-popover ref="courseTitlePopupContainer" target="courseTitle" triggers="click" placement="top" class="title_popup" container="courseTitleContainer">
              <div class="title_container">
                {{ course.title }}
              </div>
              <div class="ic_container">
                <span class="ic ic-close" v-on:click="hideCourseTitlePopup"></span>
              </div>
            </b-popover>
            <div id="courseTitleContainer" class="title_container_popup"></div>
          </div>
        </div>

        <div class="row btn_bar">
          <div class="col-2">
            <button class="btn_toc" @click="showToc">
              <span class="ic22-btnToC"></span>
            </button>
          </div>
          <b-modal id="aiContentModalContainer" class="full_screen_modal modal__v24" ref="aiContentModal"  size="" hide-footer no-close-on-backdrop no-close-on-esc>

            <div slot="modal-header" class="row header-section">
              <div class="col-1 hd_ic">
                <span class="ic ic24-ai"></span>
              </div>
              <div class="col-10 hd_txt">
                {{aiResorce.title}}
              </div>
              <div class="col-1 btn_container">
                <button class="btn_close" aria-label="close" @click="closeAiContentModal">
                  <span class="ic-close"></span>
                </button>
              </div>
            </div>

            <div class="row entity_head">
              <div class="col-12">
                <div class="hd_txt">
                  {{ course.title }}
                </div>
              </div>
            </div>

            <div class="row sub_head mt-3 mb-3">
              <div class="col-8 hd_txt">
                {{entity.title}}
              </div>

              <div class="col-4 btn_container">
                <b-btn class="btn btn_rate" aria-label="rate this resource" @click="showRateResourceModal1" v-b-tooltip.hover title="Rate this resource">
                  <span class="ic ic24-rate"></span>
                  rate
                </b-btn>
              </div>

            </div>

            <div class="rich-html-container-parent">
              <div v-html="aiResorce.htmlBody">
              </div>
            </div>

            <template v-if="ratingModalStatus">
              <div class="pragya_pg_sub_modal rating-popup" style="height: 620px;">
                <div id="rateModal" class="sub_modal_inner">

                  <div class="modal-header">
                    <div class="popup_head_txt head_txt text-center">
                      <span>Rate this Resource</span>
                    </div>
                    <div class="btn_container">
                      <button class="btn_close" aria-label="close" @click="hideRateResourceModal1">
                        <span class="ic-close"></span>
                      </button>
                    </div>
                  </div>

                  <div class="sub_modal_body modal-content">
                    <div>
                      <div class="row">
                        <div class="col-12 content_sec_inner pg_container_rate_resourse">

                          <div class="content-performance mb-3">Did this resource improve your understanding of the content?</div>
                          <div class="row ratings-row ratings-row_5">
                            <div class="col-7 d-flex align-items-center pr-0">
                              <fieldset>
                                <input class="mr-2" type="radio" name="ranking" id="five" value="5" v-model="rating" @change="enableStarAndOkButton">
                                <label class="m-0" for="five">Extremely Helpful</label>
                              </fieldset>
                            </div>
                            <div class="col-5 stars_container">
                              <label for="five">
                                <span class="ic-star-full"></span>
                                <span class="ic-star-full"></span>
                                <span class="ic-star-full"></span>
                                <span class="ic-star-full"></span>
                                <span class="ic-star-full"></span>
                              </label>
                            </div>
                          </div>
                          <br>
                          <div class="row ratings-row ratings-row_4">
                            <div class="col-7 d-flex align-items-center pr-0">
                              <input class="mr-2" type="radio" name="ranking" id="four" value="4" v-model="rating" @change="enableStarAndOkButton">
                              <label class="m-0" for="four">Very Helpful</label>
                            </div>
                            <div class="col-5 stars_container">
                              <label for="four">
                                <span class="ic-star-full"></span>
                                <span class="ic-star-full"></span>
                                <span class="ic-star-full"></span>
                                <span class="ic-star-full"></span>
                              </label>
                            </div>
                          </div>
                          <br>
                          <div class="row ratings-row ratings-row_3">
                            <div class="col-7 d-flex align-items-center pr-0">
                              <input class="mr-2" type="radio" name="ranking" id="three" value="3" v-model="rating" @change="enableStarAndOkButton">
                              <label class="m-0" for="three">Moderately Helpful</label>
                            </div>
                            <div class="col-5 stars_container">
                              <label for="three">
                                <span class="ic-star-full"></span>
                                <span class="ic-star-full"></span>
                                <span class="ic-star-full"></span>
                              </label>
                            </div>
                          </div>
                          <br>
                          <div class="row ratings-row ratings-row_2">
                            <div class="col-7 d-flex align-items-center pr-0">
                              <input class="mr-2" type="radio" name="ranking" id="two" value="2" v-model="rating" @change="enableStarAndOkButton">
                              <label class="m-0" for="two">Slightly Helpful</label>
                            </div>
                            <div class="col-5 stars_container">
                              <label for="two">
                                <span class="ic-star-full"></span>
                                <span class="ic-star-full"></span>
                              </label>
                            </div>
                          </div>
                          <br>
                          <div class="row ratings-row ratings-row_1">
                            <div class="col-7 d-flex align-items-center pr-0">
                              <input type="radio" class="mr-2" name="ranking" value="1" id="one" v-model="rating" @change="enableStarAndOkButton">
                              <label class="m-0" for="one">Not Helpful</label>
                            </div>
                            <div class="col-5 stars_container">
                              <label for="one">
                                <span class="ic-star-full"></span>
                              </label>
                            </div>
                          </div>
                          <br>
                          <div class="row ratings-row ratings-row_0">
                            <div class="col-7 d-flex align-items-center pr-0">
                              <input type="radio" class="mr-2" name="ranking" value="0" id="zero" v-model="rating" @change="enableStarAndOkButton">
                              <label class="m-0" for="zero">N/A (Not Accessible)</label>
                            </div>
                            <div class="col-5 stars_container">
                            </div>
                          </div>
                          <div class="feedback-form">
                            <div class="note-text">If you have any comments please type it in (optional)</div>
                            <textarea rows="5" cols="50" id="feedback" maxlength="1022" aria-label="share your feedback"
                              v-model.trim="feedback">
                            </textarea>
                          </div>

                        </div>
                      </div>

                      <div class="submit-btn pt-4" style="padding-right: 8px;">
                        <b-button v-on:click="sendRating" class="btn button-primary next float-right" disabled id="ok-btn" aria-label="ok"> ok </b-button>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
              <div class="pragya_pg_bg_layer" @click="hideRateResourceModal1"></div>
            </template>

        </b-modal>

          <template v-if="!showCourseDescription">
            <div class="col-10">
              <div class="btn_container" v-if="entity.objectType === 'LearningContent' || course.includeCDesc || course.includeCAI">

                <b-btn class="btn btn_ic_ai" @click="openAiContentModal" aria-label="Show Pragya AI Content" v-b-tooltip.hover title="Show Pragya AI Content" v-if="this.aiResorce.uuid">
                  <span class="ic ic24-ai"></span>
                  <span id="pragyaGuideDisplayBtn" v-if="pragyaGuideBtn" style="display: none;">.</span>
                </b-btn>


                <b-button v-if="prevTOCuuid" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: prevTOCType, entityUuid: prevTOCuuid } }" class="btn button-primary next" aria-label="previous">
                  <span class="btn_txt float-left" v-on:click="scrollUpToC">
                    <span> prev </span>
                  </span>
                </b-button>
                <b-button v-else class="btn button-primary next" disabled>
                  <span class="btn_txt" v-on:click="scrollUpToC">
                    <span> prev </span>
                  </span>
                </b-button>

                <b-button v-if="nextTOCuuid" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: nextTOCType, entityUuid: nextTOCuuid , locked:toBeLocked} }" class="btn button-primary next mr-0" aria-label="next">
                  <span class="btn_txt" v-on:click="scrollToC">
                    <span> next </span>
                  </span>
                </b-button>
                <b-button v-else class="btn button-primary next mr-0" disabled>
                  <span class="btn_txt" v-on:click="scrollToC">
                    <span> next </span>
                  </span>
                </b-button>

                <full-screen-method></full-screen-method>
              </div>
            </div>
          </template>
        </div>
        <template v-if="locked">
          <div class="row sub_hd_bar">
            <div class="col-12">
              <div class="sub_hd_txt pl-3">
                <span class="ic-lock"></span> {{entity.title}}
              </div>
            </div>
          </div>
          <div class="container-fluid flex-grow-1 container-p-y lock_entity_msg">
            <div class="ic_lock"></div>
            <div class="col-12 msg" v-if="entity.unlockReliantOnType==4">
              <p>This Micro Competency is locked because you have not completed the previous Competency!</p>
              <p>Please complete all the Micro Competency in <strong>"{{entity.unlockReliantOnTitle[0]}}"</strong> to access this.</p>
            </div>
            <div class="col-12 msg" v-if="entity.unlockReliantOnType==5">
              <p>This Micro Competency is locked because you have not completed the previous Micro Competency!</p>
              <p>Please complete  <strong>"{{entity.unlockReliantOnTitle[0]}}"</strong> Micro Competency to access this.</p>
            </div>
            <div class="col-12 msg" v-if="entity.unlockReliantOnType==3">
              <p>This Micro Competency is locked because you have not completed the Diagnostic Test!</p>
              <p>Please complete Diagnostic Test <strong>"{{entity.unlockReliantOnTitle[0]}}"</strong> to access this.</p>
            </div>
            <div class="col-12 msg" v-if="entity.unlockReliantOnType==2">
              <p>This Micro Competency will open on <strong>"{{entity.unlockReliantOnTitle[0]}}"</strong>.</p>
            </div>
            <div class="col-12 msg" v-if="entity.unlockReliantOnType==1">
              This Micro Competency will open when  "{{entity.unlockReliantOnTitle[0]}}".
            </div>
          </div>
        </template>
        <template v-if="!showCourseDescription && !locked">
          <div class="row sub_hd_bar resource">
            <div class="col-12">
              <div class="sub_hd_ic">
                <span v-if="entity.fileType === 'assessment'" class="ic ic-assessment"></span>
                <span v-if="entity.fileType === 'video'" class="ic ic-video"></span>
                <span v-if="entity.fileType === 'pdf'" class="ic ic-file-pdf"></span>
                <span v-if="entity.fileType === 'doc' || entity.fileType === 'docx'" class="ic ic-file-word"></span>
                <span v-if="entity.fileType === 'xlsx'" class="ic ic-file-excel"></span>
                <span v-if="entity.fileType === 'html'" class="ic ic-pageURL"></span>
                <span v-if="entity.fileType === 'externalurl'" class="ic ic-pageURL"></span>
                <span v-if="entity.fileType === 'other'" class="ic ic-pageURL"></span>
                <span v-if="entity.fileType === 'scorm'" class="ic ic-scorm" style="font-size: 2.4rem;"></span>
                <span v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="ic ic-image"></span>
              </div>
              <div class="sub_hd_txt">
                <v-clamp class="title_txt" autoresize :max-lines="2" id="entityTitle">{{ entity.title }}</v-clamp>

                <b-popover ref="entityTitlePopupContainer" target="entityTitle" triggers="click" placement="top" class="title_popup" container="entityTitleContainer">
                  <div class="title_container">
                    {{ entity.title }}
                  </div>
                  <div class="ic_container">
                    <span class="ic ic-close" v-on:click="hideEntityTitlePopup"></span>
                  </div>
                </b-popover>
                <div id="entityTitleContainer" class="title_container_popup"></div>
              </div>

            </div>
          </div>

          <!-- Page content -->
          <div class="container-fluid flex-grow-1 container-p-y">

            <div>
              <div v-if="entity.type !== 'ASSESSMENT'">
                <span v-html="entity.description"></span>

                <template v-if="entity.ancestor === course.uuid">
                  <div class="inst_msg" v-html="institution.messageAfterCompetencyDescription" v-if="institution.messageAfterCompetencyDescription"></div>
                </template>
                 <template v-else>
                  <div class="inst_msg" v-html="institution.messageAfterMicroCompetencyDescription" v-if="institution.messageAfterMicroCompetencyDescription"></div>
                </template>

                <div class="rich-html-container-parent ai_desc_sec" v-if="course.includeCAI && aiResorce.uuid">
                    <div class="row pg_hd">
                      <div class="col-1 hd_ic ic24-ai"></div>
                      <div class="col-10 hd_txt">
                        Pragya AI Summary
                      </div>
                    </div>
                    <div v-html="aiResorce.htmlBody"></div>
                  </div>
                </div>
              <template v-if="isEntityActivityLoaded">
                <!--
                <br>
                <template v-if="((entity.type === 'ASSESSMENT') || (entity.type === 'RESOURCE') || (entity.type === 'SCORM'))">
                  <div v-if="entity.type === 'ASSESSMENT'">
                      Time spent on this assessment is <br/>
                      <strong>{{msToTime(entityActivity.assessmentTimeTaken)}}</strong>
                  </div>
                  <div v-else>
                      Time spent on this resource is <br/>
                      <strong>{{msToTime(entityActivity.resourceTimeTaken)}}</strong>
                  </div>
                </template>
                <template v-else>
                  <div>
                    Time spent on this KC is <br/>
                    <strong>{{msToTime(entityActivity.assessmentTimeTaken + entityActivity.resourceTimeTaken)}}</strong>
                  </div>
                </template>
                -->
              </template>

              <div v-if="entity.objectType === 'LearningContent'" class="learning">
                <template v-if="( entity.type === 'RICH_HTML')">
                  <template v-if="isEntityDetailLoaded">
                      <rich-html-launch-assessment :resource-id="entityUuid" :html="entity.htmlBody" :course-id="course.uuid" @afterRender="afterRenderRichHtml"></rich-html-launch-assessment>
                  </template>
                </template>
                <template v-else>
                  <div v-if="entity.type === 'ASSESSMENT'">
                    <template v-if="isEntityDetailLoaded">
                      <assessment-detail :uuid="course.uuid" :entityUuid ="entity.uuid" :entityType="entity.objectType"></assessment-detail>
                    </template>
                  </div>
                  <div v-else>
                    <template v-if="entityActivity && entityActivity.status === 1">
                      You can continue learning this resource any time by clicking on it in the Table of Contents or by clicking "Resume".
                      <div class="btn_container">
                        <b-button :to="{ name: 'resourceLearn', params: { uuid: course.uuid, entityUuid: entity.uuid, entityType: entity.objectType } }" variant="primary" class="btn btn-md" aria-label="resume">Resume </b-button>
                      </div>
                    </template>
                    <template v-if="entityActivity && entityActivity.status === 2">
                      Great! You’re done with this learning resource.
                      <div class="btn_container">
                        <b-button :to="{ name: 'resourceLearn', params: { uuid: course.uuid, entityUuid: entity.uuid, entityType: entity.objectType } }" variant="primary" class="btn btn-md" aria-label="learn again">Learn Again</b-button>
                      </div>
                    </template>
                    <template v-if="!entityActivity || (entityActivity && entityActivity.status === 0)">
                      You can start learning this resource by clicking on "Start".
                      <div class="btn_container">
                        <b-button :to="{ name: 'resourceLearn', params: { uuid: course.uuid, entityUuid: entity.uuid, entityType: entity.objectType } }" variant="primary" class="btn btn-md" aria-label="Start">Start</b-button>
                      </div>
                    </template>
                  </div>
                </template>
              </div>
            </div>

          </div>
        </template>
        <template v-if="showCourseDescription">
          <div class="row sub_hd_bar">
            <div class="col-12">
              <div class="sub_hd_txt pl-3">
                About
              </div>
            </div>
          </div>
          <div class="container-fluid flex-grow-1 container-p-y">

            <div v-html="course.description"></div>

            <div class="btn_container pt-4">
              <b-button @click="hideCourseDescription" variant="primary" class="btn btn-md" aria-label="Continue">Continue</b-button>
            </div>

          </div>
        </template>
        <!-- / Page content -->
        <!-- Footer Navbar -->
        <template v-if="!showLastActivity">
          <template v-if="( entity.type !== 'RICH_HTML')">
            <template v-if="entityUuid">
              <course-footer-navbar :uuid="uuid" :entityUuid="entityUuid"></course-footer-navbar>
            </template>
            <template v-else>
              <course-footer-navbar :uuid="uuid"></course-footer-navbar>
            </template>
          </template>
        </template>
        <!-- / Footer Navbar -->
      </div>
    </div>


    <div class="modal_popup_container">
      <b-modal class="toc_modal" ref="tocModal" hide-footer>
        <div slot="modal-header" class="header-section">
          <div class="head_txt">
            Table of Contents
          </div>
          <div class="btn_container">
            <button class="btn_close" aria-label="close" @click="hideToc">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div>
          <table-of-contents :uuid="uuid"></table-of-contents>
        </div>
      </b-modal>
    </div>


  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import CourseFooterNavbar from '../../misc/components/./CourseFooterNavbar'
import fullScreenMethod from '../../misc/components/fullScreenMethod'
import AssessmentDetail from '../../assessment/components/AssessmentDetail'
import RichHtmlLaunchAssessment from '../../assessment/components/RichHtmlLaunchAssessment'
import { PACKAGE } from '../../../package_constants'
import VClamp from 'vue-clamp'
import TOC from './TOC'
import TableOfContents from './TableOfContents'

export default {
  name: 'entity-detail',
  props: ['uuid', 'entityType', 'entityUuid', 'topicUuid', 'subTopicUuid', 'showLastActivity', 'forceShowTour', 'locked'],
  components: {
    Navbar,
    CourseFooterNavbar,
    fullScreenMethod,
    AssessmentDetail,
    RichHtmlLaunchAssessment,
    VClamp,
    TOC,
    TableOfContents
  },
  data: () => {
    return {
      isEntityDetailLoaded: false,
      isEntityActivityLoaded: false,
      nextTOCuuid: null,
      nextTOCType: null,
      prevTOCuuid: null,
      prevTOCType: null,
      toBeLocked: false,
      toBeLockedPr: false,
      entityActivity: null,
      showCourseDescription: false,
      showFirst:true,
      aiResorce: {},
      aiContentMap: {},
      rating: -1,
      ratingModalStatus: false,
      pragyaGuideBtn: true,
      pragyaGuideModal__Ai: false
    }
  },

  mounted () {
    this.$store.commit('LOAD_ENTITY_DETAIL', {})
    this.loadCourseInfo()
  },

  methods: {
    ...mapActions([
      'loadCourseTopics',
      'loadEntityDetail',
      'loadEntityActivity',
      'loadAIResource',
      'loadAIContents',
      'loadCourseDetail'
    ]),

    showToc () {
      this.$refs.tocModal.show()
    },

    hideToc () {
      this.$refs.tocModal.hide()
    },

    async loadCourseInfo () {
      await this.loadCourseDetail(this.uuid)
      this.isEntityDetailLoaded = false
      this.isEntityActivityLoaded = false
      var entityActityInfo = {
        'courseUuid': this.uuid,
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }

      this.aiContentMap = await this.loadAIContents(this.uuid)
      this.aiResorce = {uuid:this.aiContentMap[this.entityUuid]}
      if(this.aiResorce.uuid && this.course.includeCAI ) {
        var entityDetailInfo = {
          'entityUuid': this.aiResorce.uuid,
          'entityType': 'LearningContent'
        }
        this.aiResorce  = await this.loadAIResource(entityDetailInfo)
      }
      let res = await this.loadEntityActivity(entityActityInfo)
      if (res) {
        this.entityActivity = res
        if (this.entityActivity.status === 2 || this.entityActivity.status === 3) {
          this.isEntityActivityLoaded = true
        }
      }

      await this.loadCourseTopics({uuid: this.uuid, loadDataFromServer: true})
      this.toBeLocked = false
      var i = 0
      var j = 0
      var k = 0
      for (i = 0; i < this.linearTopics.length; i++) {
        if (this.linearTopics[i].uuid === this.entityUuid) {
          for (j = i + 1; j < this.linearTopics.length; j++) {
            if(this.linearTopics[j].locked){
                this.nextTOCuuid = this.linearTopics[j].uuid
                this.nextTOCType = this.linearTopics[j].objectType
                this.toBeLocked = true
                break
            }
            if(this.course.includeCAI || this.course.includeCDesc){
                this.nextTOCuuid = this.linearTopics[j].uuid
                this.nextTOCType = this.linearTopics[j].objectType
                break
            }else{
              if (this.linearTopics[j].objectType !== 'LearningTopic') {
                this.nextTOCuuid = this.linearTopics[j].uuid
                this.nextTOCType = this.linearTopics[j].objectType
                break
              }
            }
          }
          this.toBeLockedPr = false
          for (k = i - 1; k >= -1; k--) {
            if (k === -1) {
              k = this.linearTopics.length - 1
            }
              if(this.course.includeCAI || this.course.includeCDesc){
                  this.prevTOCuuid = this.linearTopics[k].uuid
                  this.prevTOCType = this.linearTopics[k].objectType
                  if (this.linearTopics[k].objectType !== 'LearningTopic') {
                  //check if parent is locked
                    for(let r=1;(k-r)>0; r++){
                      if(this.linearTopics[k-r].objectType ==='LearningTopic'){
                          if(this.linearTopics[k-r].locked){
                              this.toBeLockedPr = true
                              this.prevTOCuuid = this.linearTopics[k-r].uuid
                              this.prevTOCType = this.linearTopics[k-r].objectType
                          }
                          break;
                      }
                    }
                  }
                  break
              }else{
                if (this.linearTopics[k].objectType !== 'LearningTopic') {
                  this.prevTOCuuid = this.linearTopics[k].uuid
                  this.prevTOCType = this.linearTopics[k].objectType
                  //check if parent is locked
                  for(let r=1;(k-r)>0; r++){
                    if(this.linearTopics[k-r].objectType ==='LearningTopic'){
                        if(this.linearTopics[k-r].locked){
                            this.toBeLockedPr = true
                            this.prevTOCuuid = this.linearTopics[k-r].uuid
                            this.prevTOCType = this.linearTopics[k-r].objectType
                        }
                        break;
                    }
                  }
                  break
                }
              }
          }
          break
        }
      }
      if (j < k || (k==0 && (this.course.includeCAI || this.course.includeCDesc))) {
        this.prevTOCuuid = null
        if (!this.entityActivity) {
          this.showCourseDescription = true
        }
      }
      if (j === this.linearTopics.length) {
        this.nextTOCuuid = null
      }
      if(i>0 && i<3 && (this.course.includeCAI || this.course.includeCDesc)){// 1 means first KC/R of C 2 means from MC
          this.prevTOCuuid = this.linearTopics[i-1].uuid
          this.prevTOCType = this.linearTopics[i-1].objectType
      }

      var entityDetailInfo = {
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      let entityRes = await this.loadEntityDetail(entityDetailInfo)
      if (entityRes && ((entityRes.type === 'ASSESSMENT') || (entityRes.type === 'RICH_HTML'))) {
        this.isEntityDetailLoaded = true
        this.hideToc()
      }

      if (entityRes && entityRes.type !== 'ASSESSMENT' && entityRes.type !== 'SCORM' && !this.showCourseDescription) {
        return this.$router.push({ name: 'resourceLearn', params: { uuid: this.course.uuid, entityUuid: this.entity.uuid, entityType: this.entity.objectType } })
      }
    },
    msToTime (s) {
      if (s === undefined) {
        return '0 hrs 0 mins 0 seconds'
      }
      var ms = s % 1000
      s = (s - ms) / 1000
      var secs = s % 60
      s = (s - secs) / 60
      var mins = s % 60
      var hrs = (s - mins) / 60
      return hrs + ' hrs ' + mins + ' mins ' + secs + ' seconds'
    },
    scrollUpToC () {
      var $container = $('.content-scroll-column')
      var $scrollTo = $('.active_row')
      $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop() - 180, scrollLeft: 0}, 300)
    },
    scrollToC () {
      var $container = $('.content-scroll-column')
      var $scrollTo = $('.active_row')
      $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop(), scrollLeft: 0}, 300)
    },
    openAiContentModal () {
    if(this.$refs.aiContentModal){
      var entityDetailInfo = {
        'entityUuid': this.aiResorce.uuid,
        'entityType': 'LearningContent'
      }
      this.loadAIResource(entityDetailInfo).then(res => {
        this.aiResorce = res
        this.$refs.aiContentModal.show()
      })
     }
    },
    closeAiContentModal () {
      this.$refs.aiContentModal.hide()
    },
    hideCourseDescription () {
      this.showCourseDescription = false
      if(this.course.includeCAI || this.course.includeCDesc){
          this.entity.title = ''
          this.entity.fileType = ''
            return this.$router.push({ name: 'entityDetail', params: { uuid: this.course.uuid, entityType: this.linearTopics[0].objectType, entityUuid: this.linearTopics[0].uuid } })
      }
      if (this.entity && this.entity.type !== 'ASSESSMENT' && this.entity.type !== 'SCORM' ) {
        return this.$router.push({ name: 'resourceLearn', params: { uuid: this.course.uuid, entityType: this.entity.objectType, entityUuid: this.entity.uuid } })
      }
    },
    showRateResourceModal1 () {
      this.ratingModalStatus = true
    },
    hideRateResourceModal1 () {
      this.ratingModalStatus = false
    },
    enableStarAndOkButton () {
      if ($('#four').is(':checked')) {
        $('.ratings-row_4').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_5, .ratings-row_3, .ratings-row_2, .ratings-row_1 ').removeClass('selected-star')
      } else if ($('#three').is(':checked')) {
        $('.ratings-row_3').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_5, .ratings-row_4, .ratings-row_2, .ratings-row_1 ').removeClass('selected-star')
      } else if ($('#two').is(':checked')) {
        $('.ratings-row_2').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_5, .ratings-row_4, .ratings-row_3, .ratings-row_1 ').removeClass('selected-star')
      } else if ($('#one').is(':checked')) {
        $('.ratings-row_1').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_5, .ratings-row_4, .ratings-row_3, .ratings-row_2 ').removeClass('selected-star')
      } else if ($('#five').is(':checked')) {
        $('.ratings-row_5').addClass('selected-star')
        $('.ratings-row_0, .ratings-row_3, .ratings-row_4, .ratings-row_2, .ratings-row_1 ').removeClass('selected-star')
      } else if ($('#zero').is(':checked')) {
        $('.ratings-row_0').addClass('selected-star')
        $('.ratings-row_3,.ratings-row_5, .ratings-row_4, .ratings-row_2, .ratings-row_1 ').removeClass('selected-star')
      }
      $('#ok-btn').prop('disabled', false)
      $('#ok-btn').removeClass('disabled')
    },
    sendRating () {
      if (this.ratingFeatureEnabled) {
        let feedback = $.trim(this.feedback)
        let entityUuid = this.uuid + '&resourceUuid=' + this.aiResorce.uuid + '&rating=' + this.rating + '&ratingComment=' + ((feedback.length > 0) ? feedback : undefined)
        this.loadLogDashboardActivity({action: 'clickRateResource', page: 'courseLearn', link: '', entityUuid: entityUuid})
        var ratingInfo = {
          'courseId': this.uuid,
          'learningContentId': this.aiResorce.uuid,
          'userId': localStorage.getItem('userid'),
          'institutionId': null,
          'rating': this.rating,
          'ratingLabel': null,
          'feedback': ((feedback.length > 0) ? feedback : null)
        }
        this.storeRating(ratingInfo)
      }
      this.ratingModalStatus = false
    },
    leaving () {
      var stopActivity = {
        'userId': localStorage.getItem('userid'),
        'entityUuid': this.entityUuid,
        'rating': this.rating
      }
      this.stopActivity(stopActivity).then((res) => {
        this.sendRating()
        this.ratingModalStatus = false
        //return this.$router.push({ name: 'entityResult', params: { uuid: this.uuid, entityType: this.entityType, entityUuid: this.entityUuid } })
      })
    },
    afterRenderRichHtml () {
      var frames = document.getElementsByTagName("iframe");
        for (let i = 0; i < frames.length; ++i)
          {
            frames[i].parentElement.setAttribute("style", "")
            frames[i].setAttribute("height", "100%")
            frames[i].setAttribute("width", "100%")
          }
      var imgs = document.getElementsByTagName("img");
        for (let i = 0; i < imgs.length; ++i)
          {
            imgs[i].parentElement.setAttribute("style", "")
            imgs[i].setAttribute("height", "100%")
            imgs[i].setAttribute("width", "100%")
          }
    },
    hideCourseTitlePopup () {
      this.$refs.courseTitlePopupContainer.$emit('close')
    },
    hideEntityTitlePopup () {
      this.$refs.entityTitlePopupContainer.$emit('close')
    }
  },

  computed: {
    ...mapState({
      'course': state => state.dashboard.course,
      'topics': state => state.dashboard.topics,
      'entity': state => state.dashboard.entity,
      'linearTopics': state => state.dashboard.linearTopics,
      'institution': state => state.dashboard.institution
    }),
    isStudentLogin: function () {
      return (localStorage.getItem('userrole') === 'Student')
    }
  },

  watch: {
    entityUuid (newId) {
      if (newId) {
        if(this.aiContentMap && this.aiContentMap[newId]){
          this.aiResorce = {uuid:this.aiContentMap[newId]}
        }else{
          this.aiResorce = {}
        }
        this.loadCourseInfo()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/EntityDetail.vue